module.exports = __webpack_public_path__ + "tau2m.jpg?674e172262e31fbc9be31e31d5737858";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tau2m.jpg
// module id = 260
// module chunks = 0